module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list-page', {
    attrs: {
      "show-panel": "",
      "sorting": "",
      "searching": "",
      "list-key": "Departments",
      "single-key": "Department",
      "fields": _vm.fields,
      "actions": _vm.actions,
      "page-title": _vm.$root.__('Departments'),
      "params": _vm.params
    },
    on: {
      "onItemClick": _vm.onItemClick
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3905fa60"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/list-departments.vue
// module id = 135
// module chunks = 1